import React, { useRef } from "react";

// ASSETS

// STYLES
import {
  ProjectsCarouselContainer,
  ProjectsSlider,
  ProjectsSliderItem,
  CarouselScrollbar,
  CarouselDot,
  CarouselDotButton,
} from "./ProjectsCarouselStyled";

// LIBRARIES
import Slider from "react-slick";

// MISC
import { IProps } from "./ProjectsCarouselModel";

// REDUX

// COMPONENTS
import ProjectCard from "components/ProjectCard/ProjectCard";

const ProjectsCarousel = (props: IProps) => {
  // PROPERTIES
  const { data } = props;
  // LIBRARY CONSTANTS

  // STATE CONSTANTS

  // Slider reference
  const sliderRef = useRef<Slider | null>(null);

  const settings = {
    // infinite: false,
    // arrows: false,
    infinite: true,
    arros: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    responsive: [
      {
        breakpoint: 3700,
        settings: {
          centerPadding: "850px",
        },
      },
      {
        breakpoint: 3500,
        settings: {
          centerPadding: "800px",
        },
      },
      {
        breakpoint: 3300,
        settings: {
          centerPadding: "750px",
        },
      },
      {
        breakpoint: 3100,
        settings: {
          centerPadding: "700px",
        },
      },
      {
        breakpoint: 2900,
        settings: {
          centerPadding: "650px",
        },
      },
      {
        breakpoint: 2700,
        settings: {
          centerPadding: "600px",
        },
      },
      {
        breakpoint: 2500,
        settings: {
          centerPadding: "550px",
        },
      },
      {
        breakpoint: 2300,
        settings: {
          centerPadding: "500px",
        },
      },
      {
        breakpoint: 2100,
        settings: {
          centerPadding: "450px",
        },
      },

      {
        breakpoint: 1720,
        settings: {
          centerPadding: "300px",
        },
      },
      {
        breakpoint: 1520,
        settings: {
          centerPadding: "260px",
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          centerPadding: "230px",
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          centerPadding: "200px",
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1227,
        settings: {
          infinite: true,
          centerMode: true,
          slidesToShow: 3,
          // centerPadding: "205px",
          dots: true,
          arrows: false,
          appendDots: (dots) => (
            <CarouselScrollbar>
              <CarouselDot> {dots} </CarouselDot>
            </CarouselScrollbar>
          ),
          customPaging: () => <CarouselDotButton />,
        },
      },
      {
        breakpoint: 900,
        settings: {
          infinite: true,
          centerMode: true,
          slidesToShow: 1,
          centerPadding: "205px",
          dots: true,
          arrows: false,
          appendDots: (dots) => (
            <CarouselScrollbar>
              <CarouselDot> {dots} </CarouselDot>
            </CarouselScrollbar>
          ),
          customPaging: () => <CarouselDotButton />,
        },
      },
      {
        breakpoint: 768,
        settings: {
          infinite: true,
          centerMode: true,
          slidesToShow: 1,
          centerPadding: "205px",
          dots: true,
          arrows: false,
          appendDots: (dots) => (
            <CarouselScrollbar>
              <CarouselDot> {dots} </CarouselDot>
            </CarouselScrollbar>
          ),
          customPaging: () => <CarouselDotButton />,
        },
      },
      {
        breakpoint: 680,
        settings: {
          infinite: true,
          centerMode: true,
          slidesToShow: 1,
          centerPadding: "170px",
          dots: true,
          arrows: false,
          appendDots: (dots) => (
            <CarouselScrollbar>
              <CarouselDot> {dots} </CarouselDot>
            </CarouselScrollbar>
          ),
          customPaging: () => <CarouselDotButton />,
        },
      },
      {
        breakpoint: 590,
        settings: {
          infinite: true,
          centerMode: true,
          slidesToShow: 1,
          centerPadding: "135px",
          dots: true,
          arrows: false,
          appendDots: (dots) => (
            <CarouselScrollbar>
              <CarouselDot> {dots} </CarouselDot>
            </CarouselScrollbar>
          ),
          customPaging: () => <CarouselDotButton />,
        },
      },
      {
        breakpoint: 550,
        settings: {
          infinite: true,
          centerMode: true,
          slidesToShow: 1,
          centerPadding: "115px",
          dots: true,
          arrows: false,
          appendDots: (dots) => (
            <CarouselScrollbar>
              <CarouselDot> {dots} </CarouselDot>
            </CarouselScrollbar>
          ),
          customPaging: () => <CarouselDotButton />,
        },
      },
      {
        breakpoint: 510,
        settings: {
          infinite: true,
          centerMode: true,
          slidesToShow: 1,
          centerPadding: "95px",
          dots: true,
          arrows: false,
          appendDots: (dots) => (
            <CarouselScrollbar>
              <CarouselDot> {dots} </CarouselDot>
            </CarouselScrollbar>
          ),
          customPaging: () => <CarouselDotButton />,
        },
      },
      {
        breakpoint: 500,
        settings: {
          infinite: true,
          centerMode: true,
          slidesToShow: 1,
          centerPadding: "75px",
          dots: true,
          arrows: false,
          appendDots: (dots) => (
            <CarouselScrollbar>
              <CarouselDot> {dots} </CarouselDot>
            </CarouselScrollbar>
          ),
          customPaging: () => <CarouselDotButton />,
        },
      },
      {
        breakpoint: 430,
        settings: {
          infinite: true,
          centerMode: true,
          slidesToShow: 1,
          centerPadding: "55px",
          dots: true,
          arrows: false,
          appendDots: (dots) => (
            <CarouselScrollbar>
              <CarouselDot> {dots} </CarouselDot>
            </CarouselScrollbar>
          ),
          customPaging: () => <CarouselDotButton />,
        },
      },
      {
        breakpoint: 330,
        settings: {
          infinite: true,
          centerMode: true,
          slidesToShow: 1,
          centerPadding: "15px",
          dots: true,
          arrows: false,
          appendDots: (dots) => (
            <CarouselScrollbar>
              <CarouselDot> {dots} </CarouselDot>
            </CarouselScrollbar>
          ),
          customPaging: () => <CarouselDotButton />,
        },
      },
    ],
  };

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS
  return (
    <ProjectsCarouselContainer>
      <ProjectsSlider ref={sliderRef} {...settings}>
        {data?.map((item) => (
          <ProjectsSliderItem key={item?.id}>
            <ProjectCard image={item?.image} text={item?.text} id={item?.id} />
          </ProjectsSliderItem>
        ))}
      </ProjectsSlider>
    </ProjectsCarouselContainer>
  );
};

export default ProjectsCarousel;
